import React, { useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Grid, Button, LinearProgress } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';

import IconExcel from '~/assets/icons/icons8-ms-excel.svg';
import { IconButton } from '~/components';
import { Autocomplete } from '~/components/Form';
import { t, number } from '~/helpers';
import { generateReport } from '~/helpers/reportUtils';
import api from '~/services/api';

import * as S from '../RelPitStopQuantidade/styles';
import { Tabela } from './components';

function RelAbastecimentoA2VF() {
  const { language } = useSelector((state) => state.user);
  const [
    datahorainicialmovimentacao,
    setDatahorainicialmovimentacao,
  ] = React.useState(null);
  const [
    datahorafinalmovimentacao,
    setDatahorafinalmovimentacao,
  ] = React.useState(null);
  const [posto, setPosto] = React.useState(null);
  const [postoObj, setPostoObj] = useState(null);
  const [idveiculo, setIdveiculo] = React.useState(null);
  const [abastecimentos, setAbastecimentos] = React.useState([]);
  const [gravando, setGravando] = React.useState(false);

  const output = useMemo(() => 'DD/MM/YYYY HH:mm:ss', [language]);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  React.useEffect(() => {
    setDatahorainicialmovimentacao(start.format('YYYY-MM-DD HH:mm:ss'));
    setDatahorafinalmovimentacao(end.format('YYYY-MM-DD HH:mm:ss'));
  }, []);

  const handleDateInicialChange = useCallback((data) => {
    if (data) {
      setDatahorainicialmovimentacao(data.format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setDatahorainicialmovimentacao(null);
    }
  }, []);

  const handleDateFinalChange = useCallback((data) => {
    if (data) {
      setDatahorafinalmovimentacao(data.format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setDatahorafinalmovimentacao(null);
    }
  }, []);

  const validaPeriodo = () => {
    if (datahorainicialmovimentacao && datahorafinalmovimentacao) {
      if (
        datahorainicialmovimentacao.length !== 19 ||
        datahorafinalmovimentacao.length !== 19
      ) {
        toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
        return false;
      }
    } else {
      toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
      return false;
    }
    return true;
  };

  const getTextoPesquisa = () => {
    let textoPesquisa = `FILTRO - ${t(
      's.geral.opcoes.datahorainicial'
    )}: ${moment(datahorainicialmovimentacao, 'YYYY-MM-DD HH:mm:ss').format(
      'DD/MM/YYYY HH:mm:ss'
    )} | ${t('s.geral.opcoes.datahorafinal')}: ${moment(
      datahorafinalmovimentacao,
      'YYYY-MM-DD HH:mm:ss'
    ).format('DD/MM/YYYY HH:mm:ss')}`;

    if (postoObj && postoObj.idposto && postoObj.codigonomeposto) {
      textoPesquisa += ` | ${t('s.geral.postocomboio')}: ${
        postoObj.codigonomeposto
      }`;
    }

    if (idveiculo && idveiculo.length > 0) {
      textoPesquisa += ` | ${t(
        's.menu.cadastro.veiculo.locomotiva'
      )}: ${idveiculo}`;
    }

    return textoPesquisa;
  };

  const handlePesquisar = async () => {
    if (!validaPeriodo()) return;

    try {
      setGravando(true);

      const { data } = await api.get('/abastecimentoa2vf', {
        params: {
          datahorainicialmovimentacao,
          datahorafinalmovimentacao,
          idposto: posto,
          idveiculo,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      setAbastecimentos(data.abastecimentos || []);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setGravando(false);
    }
  };

  const handleExport = async (formato) => {
    if (!validaPeriodo()) return;

    try {
      setGravando(true);

      await generateReport({
        endpoint: 'abastecimentoa2vf',
        params: {
          fieldlist:
            'datamovimentacao, horainicialmovimentacao, codigonomeposto, idveiculo, idbico, volumemovimentacao, possuidlocveiculo, comoverfillmovimentacaoabastecimento, overfillatuoumovimentacaoabastecimento, overfillfimatuadomovimentacaoabastecimento',
          datahorainicialmovimentacao,
          datahorafinalmovimentacao,
          idposto: posto,
          idveiculo,
          relatorio: {
            formato,
            tituloRelatorio: t('s.menu.operacao.abastecimento'),
            substituirHeader: {
              datamovimentacao: t('s.relatorio.afericao.data'),
              horainicialmovimentacao: t(
                's.geral.camposistema.horainicialmovimentacao'
              ),
              codigonomeposto: t('s.relatorio.alteracaoencerrante.posto'),
              idveiculo: t('s.cadastro.veiculo.locomotiva'),
              idbico: t('s.relatorio.abastecimentolistagem.bico'),
              volumemovimentacao: t('s.relatorio.afericao.volume'),
              possuidlocveiculo: t('s.cadastro.veiculo.possuidlocveiculo'),
              comoverfillmovimentacaoabastecimento: t(
                's.geral.comoverfillmovimentacaoabastecimento'
              ),
              overfillatuoumovimentacaoabastecimento: t(
                's.geral.overfillatuoumovimentacaoabastecimento'
              ),
              overfillfimatuadomovimentacaoabastecimento: t(
                's.geral.overfillfimatuadomovimentacaoabastecimento'
              ),
            },
            textoPesquisa: getTextoPesquisa(),
          },
        },
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else if (typeof err === 'string') toast.error(t(err));
      else console.log(err);
    } finally {
      setGravando(false);
    }
  };

  const cells = React.useMemo(
    () => [
      {
        id: 'datamovimentacao',
        label: t('s.relatorio.afericao.data'),
        format: (value) => (value ? moment(value).format('DD/MM/YYYY') : ''),
      },
      {
        id: 'horainicialmovimentacao',
        label: t('s.geral.camposistema.horainicialmovimentacao'),
      },
      {
        id: 'codigonomeposto',
        label: t('s.relatorio.alteracaoencerrante.posto'),
      },
      {
        id: 'idveiculo',
        label: t('s.cadastro.veiculo.locomotiva'),
      },
      {
        id: 'idbico',
        label: t('s.relatorio.abastecimentolistagem.bico'),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.relatorio.afericao.volume'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'possuidlocveiculo',
        label: t('s.cadastro.veiculo.possuidlocveiculo'),
      },
      {
        id: 'comoverfillmovimentacaoabastecimento',
        label: t('s.geral.comoverfillmovimentacaoabastecimento'),
      },
      {
        id: 'overfillatuoumovimentacaoabastecimento',
        label: t('s.geral.overfillatuoumovimentacaoabastecimento'),
      },
      {
        id: 'overfillfimatuadomovimentacaoabastecimento',
        label: t('s.geral.overfillfimatuadomovimentacaoabastecimento'),
      },
    ],
    []
  );

  return (
    <>
      {gravando && <LinearProgress />}
      <S.DatePickerWrapper>
        <Grid
          container
          spacing={2}
          padding={2}
          alignItems="center"
          style={{ marginTop: '5px' }}
        >
          <Grid
            item
            xs={14}
            md={14}
            lg={14}
            container
            spacing={1}
            justifyContent="flex-start"
          >
            <Grid item xs={6} sm={12} md="auto">
              <S.DatePicker
                name="datahorainicialmovimentacao"
                ampm={false}
                size="small"
                inputVariant="outlined"
                cancelLabel={t('s.geral.botaocancelar')}
                format={output}
                onChange={handleDateInicialChange}
                value={datahorainicialmovimentacao}
                KeyboardButtonProps={{ padding: 0 }}
                invalidDateMessage=""
              />
            </Grid>
            <Grid item xs={6} sm={12} md="auto">
              <S.DatePicker
                name="datahorafinalmovimentacao"
                size="small"
                ampm={false}
                inputVariant="outlined"
                cancelLabel={t('s.geral.botaocancelar')}
                format={output}
                onChange={handleDateFinalChange}
                value={datahorafinalmovimentacao}
                KeyboardButtonProps={{ padding: 0 }}
                invalidDateMessage=""
              />
            </Grid>
            <Grid item>
              <Autocomplete
                fullWidth
                name="posto"
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.geral.postocomboio')}
                style={{ minWidth: '160px' }}
                hiddens={[{ name: 'codigonomeposto' }]}
                getValue={(value) => {
                  setAbastecimentos([]);
                  if (value.idposto !== null) {
                    setPosto(value.idposto);
                    setPostoObj(value);
                  } else {
                    setPosto(null);
                    setPostoObj(null);
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} sm={12} md="auto">
              <Autocomplete
                fullWidth
                name="idveiculo"
                label="idveiculo"
                url="veiculos"
                unique="idveiculo"
                title={t('s.menu.cadastro.veiculo.locomotiva')}
                style={{ minWidth: '140px' }}
                getValue={(value) => {
                  setAbastecimentos([]);
                  if (value.idveiculo !== null) {
                    setIdveiculo(value.idveiculo);
                  } else {
                    setIdveiculo('');
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} sm={12} md="auto">
              <Button
                size="medium"
                variant="contained"
                color="primary"
                onClick={handlePesquisar}
                disabled={gravando}
                fullWidth={false}
              >
                {t('s.geral.pesquisar')}
              </Button>
            </Grid>
            <Grid item xs={6} sm={12} md="auto">
              <IconButton
                type="button"
                startIcon={
                  <PictureAsPdfIcon
                    style={{ color: 'white', width: 20, height: 20 }}
                  />
                }
                backgroundColor="#d32f2f"
                color="white"
                iconSize={20}
                onClick={() => handleExport('PDF')}
                style={{ minWidth: 40, width: 40, maxWidth: 40 }}
                disabled={abastecimentos.length === 0 || gravando}
              />
            </Grid>
            <Grid item xs={6} sm={12} md="auto">
              <IconButton
                type="button"
                startIcon={
                  <img
                    src={IconExcel}
                    alt="Excel"
                    style={{
                      width: 20,
                      height: 20,
                      filter: 'invert(1)',
                    }}
                  />
                }
                backgroundColor="#2e7d32"
                color="white"
                iconSize={20}
                onClick={() => handleExport('EXCEL')}
                style={{ minWidth: 40, width: 40, maxWidth: 40 }}
                disabled={abastecimentos.length === 0 || gravando}
              />
            </Grid>
          </Grid>
        </Grid>
      </S.DatePickerWrapper>
      <Tabela
        title=""
        cells={cells}
        data={abastecimentos}
        height="80vh"
        size="small"
      />
    </>
  );
}

export default RelAbastecimentoA2VF;
